import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../modules/app/mainReducer";
import { questionarioSatisfacaoActions } from "../modules/questionario-satisfacao/reducer";
import { getQuestionarioSatisfacaoCodigo } from "../utils/questionarioSatisfacaoRegras";

export function useGetQuestionarioSatisfacao() {
  const dispatch = useDispatch();

  const networkOnline = useSelector((state: RootState) => state.login?.networkOnline);
  const pesquisaUpdatedAt = useSelector(
    (state: RootState) => state.questionarioSatisfacao?.pesquisa_updated_at
  );
  const pesquisa = useSelector((state: RootState) => state.questionarioSatisfacao?.pesquisa);

  if (!getQuestionarioSatisfacaoCodigo()) {
    return;
  }

  const lastUpdateTime = (pesquisaUpdatedAt ? new Date(pesquisaUpdatedAt) : new Date()).getTime();
  const currentTime = new Date().getTime();
  const minutesPassed = (currentTime - lastUpdateTime) / (1000 * 60);

  if ((minutesPassed > 60 && networkOnline) || (!pesquisa && networkOnline)) {
    dispatch(questionarioSatisfacaoActions.questionarioSatisfacaoRequest());
  }
}
